import { render } from "./FloatingHeader.vue?vue&type=template&id=3a014629&scoped=true"
import script from "./FloatingHeader.vue?vue&type=script&lang=js"
export * from "./FloatingHeader.vue?vue&type=script&lang=js"

import "./FloatingHeader.vue?vue&type=style&index=0&id=3a014629&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a014629"]])

export default __exports__